import DashboardPreferencesReduxState from '../../@types/DashboardPreferencesReduxState';

export default function clearPreferencesAction(): DashboardPreferencesReduxState {
  return null;
}
